import request, { METHODS } from "src/utils/api-base";

const notificationApis = {
  getNotificationList: (params: {
    page?: number;
    limit: number;
    unreadOnly?: boolean;
  }) => {
    return request({
      route: "/app/notifications",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },

  getUnreadCount: () => {
    return request({
      route: "/app/notifications/unread-count",
      method: METHODS.GET,
      auth: true,
    });
  },

  markNotificationRead: (_id: string) => {
    return request({
      route: `/app/notifications/${_id}/read`,
      method: METHODS.PATCH,
      auth: true,
    });
  },

  markAllNotificationsRead: () => {
    return request({
      route: "/app/notifications/mark-all-read",
      method: METHODS.PATCH,
      auth: true,
    });
  },
};

export default notificationApis;
